export default {"src":"/_next/static/media/garden-flower.72ef4f93.svg","height":105,"width":133,"blurWidth":0,"blurHeight":0};